import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const RadioEmpty = ({ size = 34, style, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.background;

  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none" style={style}>
      <rect x="5" y="5" width="24" height="24" rx="12" fill={fill} />
    </svg>
  );
};
